<template>
  <span
    :class="classes"
    v-html="icon"
  />
</template>

<script setup lang="ts">
import { ref, watchEffect } from '#imports';

const { name, filled = false } = defineProps<{
  name: string;
  filled?: boolean;
}>();

const icon = ref<string | Record<string, string>>('');
const hasStroke = ref<boolean>(false);

const getIcon = async () => {
  try {
    const iconsImport = import.meta.glob('/assets/icons/**/**.svg', {
      eager: false,
      query: '?raw',
      import: 'default',
    });
    const iconLoader = iconsImport[`/assets/icons/${name}.svg`];

    if (!iconLoader) {
      return;
    }
    const rawIcon = await iconLoader();

    if (!rawIcon || typeof rawIcon !== 'string') {
      return;
    }
    if (rawIcon.includes('stroke')) {
      hasStroke.value = true;
    }
    icon.value = rawIcon;
  }
  catch {
    console.error(
      `[nuxt-icons] Icon '${name}' doesn't exist in 'assets/icons'`,
    );
  }
};

getIcon();

watchEffect(getIcon);

const classes = computed(() => [
  'nuxt-icon',
  {
    'nuxt-icon--fill': !filled,
    'nuxt-icon--stroke': hasStroke.value && !filled,
  },
]);
</script>

<style lang="scss" scoped>
.nuxt-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  &--fill, &--fill * {
    fill: currentColor !important;
  }

  &--stroke, &--stroke * {
    stroke: currentColor !important;
  }

  :deep(svg) {
    width: 100%;
    height: 100%;
    color: inherit;
  }
}
</style>
